export function normalizePostalCode(postalCode?: string | null): string {
  return (postalCode ?? '').replace(/\D/g, '')
}

export function maskPostalCodeTyping(rawInput: string): string {
  let digitsOnly = normalizePostalCode(rawInput)

  if (digitsOnly.length > 5) {
    digitsOnly = digitsOnly.replace(/(\d{5})(\d{1,3})/, '$1-$2')
  }

  return digitsOnly
}

export function isCompletePostalCode(value: string): boolean {
  return value.length === 9
}
